import { AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT } from '../../constants';
import AmplitudeUtils from '../../utils/amplitude-utils';
import BaseMfaVerifyCustomizer from './base';

export default class AuthenticatorVerificationDataCustomizer extends BaseMfaVerifyCustomizer {

  primaryButtonClassName = 'fe_u_margin--bottom-small';
  async shouldCustomize() {
    return [ 'authenticator-verification-data' ].includes(this.context.formName);
  }

  protected forgifyController() {
    this.emitAmplitudeLandingEvent();
    super.forgifyController();
  }

  emitAmplitudeLandingEvent() {
    AmplitudeUtils.logMfaChallengeEvent(`Landing::${AUTHENTICATOR_METHOD_KEY_AMPLITUDE_EVENT[this.context.authenticatorKey]}FactorSelect`);
  }

  primaryButtonOnClick = () => {
    if (this.context.authenticatorKey === 'phone_number') {
      AmplitudeUtils.logMfaChallengeEvent('SMS::SendCodeButtonClick');
    }
    else if (this.context.authenticatorKey === 'okta_verify') {
      AmplitudeUtils.logMfaChallengeEvent('OktaVerify::SendPushButtonClick');
    }
  };

  tertiaryButtonOnClick = () => {
    if (this.context.authenticatorKey === 'phone_number') {
      AmplitudeUtils.logMfaChallengeEvent('VoiceCall::CallButtonClick');
    }
  };

}
